import SendIcon from "@mui/icons-material/Send";
import React from "react";
import { Button, SimpleForm, Toolbar } from "react-admin";
import { FieldValues } from "react-hook-form";

import FingridTestGenericPlanningItem from "./FingridTestGenericPlanningItem";
import useFingridTestGenericPlanningsForm from "./hooks/useFingridTestGenericPlanningsForm";
import { GenericPlanningConfig, GenericPlanningValue } from "./types";

type Props = {
  initialData: FieldValues;
  configs: GenericPlanningConfig[];
  defaultValues: Record<string, GenericPlanningValue>;
  lockSocEndDate?: boolean;
};

const FingridTestGenericPlanningsForm: React.FC<Props> = ({
  initialData,
  configs,
  defaultValues,
  lockSocEndDate = true,
}) => {
  const { handleSubmit, isLoading, orderedConfigs } = useFingridTestGenericPlanningsForm(initialData, configs);

  return (
    <SimpleForm
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      toolbar={
        <Toolbar>
          <Button
            variant="contained"
            size="large"
            label="Submit plannings"
            disabled={isLoading}
            type="submit"
            startIcon={<SendIcon />}
          />
        </Toolbar>
      }
    >
      {orderedConfigs.map((config, index) => (
        <FingridTestGenericPlanningItem
          key={config.name}
          allConfigs={orderedConfigs}
          config={config}
          index={index}
          initialData={initialData}
          lockSocEndDate={lockSocEndDate}
        />
      ))}
    </SimpleForm>
  );
};

export default FingridTestGenericPlanningsForm;
